import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Header from './Headers';
import Loader from './loader'
import MetaTags from 'react-meta-tags';
import ReactGA from 'react-ga';

@inject('store')
@observer
class Emailerlogin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            name: '',
            mobile_number: '',
            errors: '',
            message: '',
            loader: false,
            success: false,
            emailvalidation: '',
            screen: 1,
        }
    }

    componentDidMount() {
        this.initializeReactGA();
        window.scrollTo(0, 0);
    }

    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/campaignform');
    }

    handleValidation() {
        let formdatas = this.state
        let errors = {};
        let formIsValid = true;

        if (!formdatas["name"]) {
            formIsValid = false;
            errors["name"] = "Name is require";
        }

        if (formdatas['email'] == '') {
            var numbers = /^[0-9]+$/;
            if (!formdatas["mobile_number"].match(numbers)) {
                formIsValid = false;
                errors["mobile_number"] = "Mobile Number Not a Valid Number"
            }

            if (formdatas["mobile_number"].length != 10) {
                formIsValid = false;
                errors["mobile_number"] = "Mobile Number Must have 10 digit"
            }

            if (!formdatas["mobile_number"]) {
                formIsValid = false;
                errors["mobile_number"] = "Mobile Number is required";
            }
        } else {

            if (!formdatas["email"]) {
                formIsValid = false;
                errors["email"] = "Cannot be empty";
            }

            if (typeof formdatas["email"] !== "undefined") {
                let lastAtPos = formdatas["email"].lastIndexOf('@');
                let lastDotPos = formdatas["email"].lastIndexOf('.');

                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && formdatas["email"].indexOf('@@') == -1 && lastDotPos > 2 && (formdatas["email"].length - lastDotPos) > 2)) {
                    formIsValid = false;
                    errors["email"] = "Email is not valid";
                }
            }
        }


        if (!formdatas["message"]) {
            formIsValid = false;
            errors["message"] = "Message is require";
        }

        this.setState({errors: errors});
        return formIsValid;
    }

    onchangevalue(e) {
        let value = this.state;
        value[e.target.name] = e.target.value;
        this.setState(value)
    }

    contactUs(e) {
        e.preventDefault()
        if (this.handleValidation()) {
            this.setState({loader: true})
            var form = JSON.stringify({
                email: this.state.email,
                name: this.state.name,
                message: this.state.message,
                campaign: 1,
                phone: this.state.mobile_number
            })
            console.log(form)
            fetch("https://revfin.in/v3/api/contactus", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: form
            })
                .then(response => response.json())
                .then(res => {
                    this.setState({loader: false});
                    console.log(res)
                    if (res.message == 'Thank you') {
                        this.setState({
                            name: '',
                            email: '',
                            message: '',
                            mobile_number: '',
                            success: true,
                            emailvalidation: ''
                        });
                        setTimeout(() => {
                            this.setState({success: false})
                        }, 3000)
                    } else if (res.error == true) {
                        this.setState({emailvalidation: res.message})
                    }

                })
        }
    }

    render() {
        return (
            <div>
                <MetaTags>
                    <title>Revfin</title>
                    <meta name="description" content="Some description."/>
                    <meta property="og:title" content="MyApp"/>
                    <meta property="og:image" content="path/to/image.jpg"/>
                </MetaTags>
                <Header/>
                <section className="banner_text headerbg">
                    <div className="container">
                        <div className="aboutusbanner full-w text-center ">
                        </div>
                    </div>
                </section>
                <section className="pdtb-20">
                    <div className="container">
                        <div className="logincenter">
                            <div className="loginarea">
                                <div className={`successfullymessage ${this.state.success ? 'showmessage' : ''}`}>Thank
                                    you for showing your interest
                                </div>
                                <form className="form-inline errohandle" role="form"
                                      onSubmit={this.contactUs.bind(this)}>

                                    <div className="full-w">
                                        <input type="text" className="mb-2 mr-sm-2 textwidth" name="name"
                                               placeholder="Name"
                                               value={this.state.name}
                                               onChange={this.onchangevalue.bind(this)}
                                        />
                                        <div className="full-w error">{this.state.errors["name"]}</div>
                                    </div>


                                    <div className="full-w myflex f-between form-group">
                                        <div className="half-w">
                                            <input type="tel" className="mb-2 mr-sm-2 textwidth" name="mobile_number"
                                                   placeholder="Mobile Number" maxLength="10"
                                                   value={this.state.mobile_number}
                                                   onChange={this.onchangevalue.bind(this)}
                                            />
                                            <div className="full-w error">{this.state.errors["mobile_number"]}</div>
                                        </div>
                                        <div className="half-w">
                                            <input type="text" className="mb-2 mr-sm-2 textwidth" name="email"
                                                   placeholder="Email ID"
                                                   value={this.state.email}
                                                   onChange={this.onchangevalue.bind(this)}
                                            />
                                            <div className="full-w error">{this.state.errors["email"]}</div>
                                        </div>
                                    </div>

                                    <div className="full-w">
			<textarea className="full-w textwidth" rows="5" name="message" placeholder="Your Message"
                      value={this.state.message}
                      onChange={this.onchangevalue.bind(this)}
            ></textarea>
                                        <div className="full-w error">{this.state.errors["message"]}</div>
                                    </div>

                                    <div className="full-w myflex f-between flex-center">
                                        <button type="submit" className="btn submitbutton mb-2">Submit</button>
                                        {this.state.loader ? <Loader/> : ''}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}


export default Emailerlogin



// WEBPACK FOOTER //
// ./src/components/emailerlogin.js